import React, { useState, useEffect } from 'react'
import QuestionItem from '@/component/question/question'
import Loading from '@/component/loading/loading'
import { useSearchParams } from 'react-router-dom'
import { post } from '@/api/http'
import './question.scss'
import { questionMap } from '@/data/questionMap'
const Question = () => {
  // 设置状态
  const [showLoading, setShowLoading] = useState(true)
  const [question, setQuestion] = useState({})
  const [params] = useSearchParams()
  const questionId = params.get('id')

  // 在组件加载时，如果没有提供 id，则不执行查询
  useEffect(() => {
    const getQuestionInfo = async (id) => {
      setShowLoading(true)
      try {
        const questionsList = await post(`jq/v5/questions/batch`, {
          ids: [questionMap[Number(questionId)] ?? questionId],
        })

        if (questionsList?.length > 0) {
          setQuestion(questionsList[0])
        }
      } catch (err) {
        console.error(err)
      } finally {
        setShowLoading(false)
      }
    }
    getQuestionInfo(questionId)
  }, [questionId])

  // 根据 loading 状态显示组件
  return (
    <div>
      {showLoading ? (
        <Loading loadingText="获取题库中,请等待..." />
      ) : (
        <QuestionItem question={question} />
      )}
    </div>
  )
}

export default Question
